import React, { useState } from 'react';
import styled from 'styled-components';
import { AppCard } from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import Translator from '../../../../components/helpers/Translator';
import colors from '../../../../../constants/colors';

export default function ModuleComsaEnvironmentalConstructionPotentialsAspectsCard(
  props
) {
  const { motive, values } = props;
  const [probability] = useState([
    <Translator file="module-comsaEnvironmental" name="none" />,
    <Translator file="module-comsaEnvironmental" name="low" />,
    <Translator file="module-comsaEnvironmental" name="medium" />,
    <Translator file="module-comsaEnvironmental" name="high" />,
  ]);
  const [gravity] = useState([
    <Translator file="module-comsaEnvironmental" name="none" />,
    <Translator file="module-comsaEnvironmental" name="low" />,
    <Translator file="module-comsaEnvironmental" name="moderate" />,
    <Translator file="module-comsaEnvironmental" name="remarkable" />,
  ]);
  const [valuationText] = useState([
    <Translator
      file="module-comsaEnvironmental"
      name="no.applicable"
    />,
    <Translator file="module-comsaEnvironmental" name="not-significant" />,
    <Translator file="module-comsaEnvironmental" name="significant" />,
  ]);

  return (
    <Container className="mb-2" bodyClassName="p-1">
      <div className="info-block">
        <div className="line mb-2">
          <div>
            <Translator file="module-comsaEnvironmental" name="reason" /> /{' '}
            <Translator
              file="module-comsaEnvironmental"
              name="construction.phase"
            />
            :
          </div>
          <div>
            <b>{motive}</b>
          </div>
        </div>
        <div className="line mb-2">
          <div>
            <Translator file="module-comsaEnvironmental" name="probability" />:
          </div>
          <div>
            <b>{probability[values?.probability] || ''}</b>
          </div>
        </div>
        <div className="line mb-2">
          <div>
            <Translator file="module-comsaEnvironmental" name="gravity" /> :
          </div>
          <div>
            <b>{gravity[values?.gravity] || ''}</b>
          </div>
        </div>
        <div className="line mb-2">
          <div>
            <Translator file="module-comsaEnvironmental" name="valuation" />:
          </div>
          <div
            className={
              values?.valuationText === 2
                ? 'text-danger'
                : values?.valuationText === 1
                ? 'text-warning'
                : 'text-success'
            }
          >
            <b>{valuationText[values?.valuationText] || ''}</b>
          </div>
        </div>
      </div>
    </Container>
  );
}

const Container = styled(AppCard)`
  .info-block {
    display: flex;
    text-align: center;
    flex-direction: column;
    @media (min-width: 768px) {
      flex-direction: row;
    }
    .line {
      flex: 1 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      color: ${colors.primaryLight};
    }
  }
`;
